import userPerms from "@/services/userPermissionsToPortfolio.service";
import permissions from '@/UserPermissions/PermissionGroups';
import Formatter from '@/functions/Formatter';

const state = {
    userPermissions:{
        id: 0,
        contactId: 0,
        portfolioId: 0,
        permissions: 0
    }
}

const mutations = {
    SET_ALL(state, data){
        state.userPermissions = data;
    },
    SET_PERMISSIONS(state, data){
        state.userPermissions.permissions = data;
    }
}

const actions = {
    async setUserPermissions({ commit }, permissions){
        commit("SET_PERMISSIONS", permissions);
        return;
    },
    async fetchUserPermissions({ commit }, data){
        try{
            let response = await userPerms.getOne(data.portfolioId, data.contactId);
            let isFetched = true;

            if(!response.data?.userPermissions){
                let perms = {
                    portfolio: {
                        id: data.portfolioId
                    },
                    contact:{
                        id: data.contactId
                    },
                    permissions: permissions.PermissionGroups.Guest.Permissions
                }

                response = await userPerms.add(perms);
                isFetched = false;
            }

            if(response.data){
                const perms = Formatter.formatUserPermissions(isFetched ? response.data.userPermissions : response.data);
                commit('SET_ALL', perms);
            }
        }
        catch (error) {
            console.log(error);
            return undefined;
        }
    },
    // async addBrandNewUserPermissions(data){
    //     let form = new FormData();
    //     form.append()
    // }
}

const getters = {
    getUserPermissions: (state) => {
        return state.userPermissions;
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}